import { classnames } from '@aibees/shared/utils';
import { Button, Stack } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DialogFooterProps as Props } from './types';

export const DialogFooter = memo(
  ({ className, closeModal, onCancel, onConfirm }: Props) => {
    const handleConfirm = () => {
      onConfirm?.();
    };

    const handleCancel = () => {
      onCancel?.();
      closeModal();
    };

    return (
      <Styled.Wrapper
        className={classnames('DialogFooter', className)}
        sx={SX.root}
      >
        <Stack direction="row" justifyContent="space-between" width="100%">
          <Button
            variant="text"
            color="inherit"
            onClick={handleCancel}
            size="small"
          >
            No, Stay on Current Plan
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirm}
            size="small"
          >
            Yes, Downgrade to Free Plan
          </Button>
        </Stack>
      </Styled.Wrapper>
    );
  }
);

DialogFooter.displayName = 'DialogFooter';
